import { render, staticRenderFns } from "./NavbarBrand.vue?vue&type=template&id=0056b3c2&scoped=true&"
import script from "./NavbarBrand.vue?vue&type=script&lang=js&"
export * from "./NavbarBrand.vue?vue&type=script&lang=js&"
import style0 from "./NavbarBrand.vue?vue&type=style&index=0&id=0056b3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0056b3c2",
  null
  
)

export default component.exports